import EmailIcon from '@mui/icons-material/AlternateEmail';
import SelectIcon from '@mui/icons-material/ArrowDropDownCircle';
import CalculateIcon from '@mui/icons-material/Calculate';
import DateIcon from '@mui/icons-material/CalendarToday';
import CheckboxIcon from "@mui/icons-material/CheckBox";
import ReferenceIcon from "@mui/icons-material/Commit";
import ObjectIcon from '@mui/icons-material/DataObject';
import DateRangeIcon from '@mui/icons-material/DateRange';
import AddressIcon from '@mui/icons-material/Email';
import DateTimeIcon from '@mui/icons-material/Event';
import TextIcon from "@mui/icons-material/FormatColorText";
import LabelIcon from '@mui/icons-material/TextFieldsRounded';
import UrlIcon from "@mui/icons-material/Link";
import RelatedObjectsIcon from "@mui/icons-material/ListAlt";
import TagsIcon from '@mui/icons-material/LocalOffer';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import NumberIcon from "@mui/icons-material/Numbers";
import PhoneIcon from '@mui/icons-material/Phone';
import OtherIcon from '@mui/icons-material/QuestionMark';
import TimeIcon from '@mui/icons-material/Schedule';
import PostalCodeIcon from '@mui/icons-material/Signpost';
import ViewListIcon from '@mui/icons-material/ViewList';
import HiddenIcon from "@mui/icons-material/VisibilityOff";
import FunctionsIcon from '@mui/icons-material/Functions';
import DataArrayIcon from '@mui/icons-material/DataArray';
import GenericIcon from '@mui/icons-material/HdrAuto';
import DictionaryIcon from '@mui/icons-material/ImportContactsRounded';
import BitwiseIcon from '@mui/icons-material/TuneRounded';
import DistanceIcon from '@mui/icons-material/ArchitectureRounded';
import { FieldTEnum } from '@crochik/auto-pi';

export function FieldTypeIcon({ type }: { type?: FieldTEnum; }) {
    switch (type) {
        case FieldTEnum.CheckboxField:
            return <CheckboxIcon />;
        case FieldTEnum.HiddenField:
            return <HiddenIcon />;
        case FieldTEnum.NumberField:
            return <NumberIcon />;
        case FieldTEnum.ReferenceField:
        case FieldTEnum.MultiReferenceField:
            return <ReferenceIcon />;
        case FieldTEnum.RelatedObjectsField:
            return <RelatedObjectsIcon />;
        case FieldTEnum.TextField:
            return <TextIcon />;
        case FieldTEnum.UrlField:
            return <UrlIcon />;
        case FieldTEnum.DateField:
            return <DateIcon />;
        case FieldTEnum.DateTimeField:
            return <DateTimeIcon />;
        case FieldTEnum.DateRangeField:
            return <DateRangeIcon />;
        case FieldTEnum.TimeField:
            return <TimeIcon />;
        case FieldTEnum.TagsField:
            return <TagsIcon />;
        case FieldTEnum.ObjectField:
            return <ObjectIcon />;
        case FieldTEnum.ChildrenField:
            return <ViewListIcon />;
        case FieldTEnum.EmailField:
            return <EmailIcon />;
        case FieldTEnum.AddressField:
            return <AddressIcon />;
        case FieldTEnum.PhoneField:
            return <PhoneIcon />;
        case FieldTEnum.SelectField:
        case FieldTEnum.MultiSelectField:
            return <SelectIcon />;
        case FieldTEnum.PostalCodeField:
            return <PostalCodeIcon />;
        case FieldTEnum.CalculatedField:
            return <CalculateIcon />;
        case FieldTEnum.LocationField:
            return <MyLocationIcon />;
        case FieldTEnum.ExpressionField:
            return <FunctionsIcon />;
        case FieldTEnum.ArrayField:
            return <DataArrayIcon />;
        case FieldTEnum.GenericField:
            return <GenericIcon />;
        case FieldTEnum.DictionaryField:
            return <DictionaryIcon />;
        case FieldTEnum.BitwiseFlagField:
            return <BitwiseIcon />;
        case FieldTEnum.LocationDistanceField:
            return <DistanceIcon />;
        case FieldTEnum.LabelField:
            return <LabelIcon />;


        // TBD:
        case FieldTEnum.FileField:
        case FieldTEnum.ImageField:
        case FieldTEnum.PasswordField:
        case FieldTEnum.LookupField:
            return <OtherIcon />;

        // DICTIONARY = 'dictionary',
        // FILE = 'file',
        // LABEL = 'label',
        // LOOKUP = 'lookup',
        // PASSWORD = 'password',
        // POSTALCODE = 'postalcode',
        // APPOINTMENT
    }

    return <div><OtherIcon /><span>{type}</span></div>
}
